import * as React from 'react';
const Sunset = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-sunset", ...props },
    React.createElement("path", { d: "M17 18a5 5 0 0 0-10 0" }),
    React.createElement("line", { x1: "12", y1: "9", x2: "12", y2: "2" }),
    React.createElement("line", { x1: "4.22", y1: "10.22", x2: "5.64", y2: "11.64" }),
    React.createElement("line", { x1: "1", y1: "18", x2: "3", y2: "18" }),
    React.createElement("line", { x1: "21", y1: "18", x2: "23", y2: "18" }),
    React.createElement("line", { x1: "18.36", y1: "11.64", x2: "19.78", y2: "10.22" }),
    React.createElement("line", { x1: "23", y1: "22", x2: "1", y2: "22" }),
    React.createElement("polyline", { points: "16 5 12 9 8 5" })));
export default Sunset;
//# sourceMappingURL=Sunset.js.map